import { useState } from "react";

export const useInput = initVal => {
  const [value, setValue] = useState(initVal);
  const _setValueFromEventOrDirectly = e => {
    if (typeof e === "object") {
      setValue(e.target.value);
    }
    if (typeof e === "string") {
      setValue(e);
    }
  };
  return [value, _setValueFromEventOrDirectly];
};
